import SuiBox from "components/SuiBox";

import ProductTable from "pages/unionwear/components/ProductTable";
import UnionwearLayout from "pages/unionwear/layout";

const UnionwearProductPage = () => {
  return (
    <SuiBox>
      <UnionwearLayout>
        <ProductTable />
      </UnionwearLayout>
    </SuiBox>
  );
};

export default UnionwearProductPage;
